

import { useState, useEffect } from "react"
import "./userDetail.css"
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import styled from 'styled-components';

const Button = ({ children, onClick, disabled, type = "button", className = "", variant = "default" }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`btn ${variant === "default" ? "btn-primary" : "btn-ghost"} ${className}`}
  >
    {children}
  </button>
)

const Card = ({ children, className = "" }) => <div className={`card ${className}`}>{children}</div>

const CardHeader = ({ children }) => <div className="card-header">{children}</div>
const CardTitle = ({ children, className = "" }) => <h3 className={`card-title ${className}`}>{children}</h3>
const CardContent = ({ children, className = "" }) => <div className={`card-content ${className}`}>{children}</div>

const Input = ({ type, value, onChange, min, className = "", placeholder, name, maxLength }) => (
  <input
    type={type}
    name={name}
    value={value}
    onChange={onChange}
    min={min}
    maxLength={maxLength}
    className={`form-control ${className}`}
    placeholder={placeholder}
  />
)

const Select = ({ children, value, onChange, name, disabled, className = "" }) => (
  <select name={name} value={value} onChange={onChange} disabled={disabled} className={`form-control ${className}`}>
    {children}
  </select>
)

const SelectItem = ({ children, value }) => <option value={value}>{children}</option>

const Textarea = ({ placeholder, value, onChange, className = "", name, rows }) => (
  <textarea
    name={name}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    rows={rows}
    className={`form-control ${className}`}
  />
)

const Icons = {
  Calendar: () => <span className="icon-bounce">📅</span>,
  Clock: () => <span className="icon-pulse">🕐</span>,
  User: () => <span className="icon-bounce">👤</span>,
  MessageSquare: () => <span className="icon-pulse">💬</span>,
  CreditCard: () => <span className="icon-bounce">💳</span>,
  CheckCircle: () => <span className="icon-success">✅</span>,
  Loader2: () => <span className="icon-spin">⏳</span>,
  Stethoscope: () => <span className="icon-pulse">🩺</span>,
  Heart: () => <span className="icon-heartbeat">❤️</span>,
  Sparkles: () => <span className="icon-sparkle">✨</span>,
  ArrowRight: () => <span className="icon-slide">→</span>,
  Phone: () => <span className="icon-bounce">📱</span>,
  Lock: () => <span className="icon-pulse">🔐</span>,
  MapPin: () => <span className="icon-bounce">📍</span>,
  Mail: () => <span className="icon-pulse">📧</span>,
}

function UserDetail() {
  const [message, setMessage] = useState("")
  const [states, setStates] = useState([])
  const [selectedState, setSelectedState] = useState("")
  const [cities, setCities] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedCity, setSelectedCity] = useState("")
const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("")
  const [isSearching, setIsSearching] = useState(false)
  const [patientData, setPatientData] = useState(null)
  const [showForm, setShowForm] = useState(false)
  const [relations, setRelations] = useState([])
  const [userRelations, setUserRelations] = useState([])
  const [error, setError] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [showAddForm, setShowAddForm] = useState(false)
  const [selectedRelativeId, setSelectedRelativeId] = useState("")

  // New state variables for OTP functionality
  const [showOtpInput, setShowOtpInput] = useState(false)
  const [otp, setOtp] = useState("")
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false)
  const [otpVerified, setOtpVerified] = useState(false)
  const [serverOtp, setServerOtp] = useState("")

  // Form data for patient details
  const [formData, setFormData] = useState({
    salutation: "Miss",
    name: "",
    ageYears: 0,
    ageMonths: 0,
    ageDays: 0,
    dateOfBirth: "",
    mobile: "",
    email: "",
    gender: "Female",
    addressLine1: "",
    addressLine2: "",
    state: "",
    city: "",
    country: "India",
    referredBy: "",
    relation_id: "",
  })

  const [appointmentParams, setAppointmentParams] = useState({})

  useEffect(() => {
    fetchStates()
  }, [])

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)

    setAppointmentParams({
      doctor_id: queryParams.get("doctor_id") || "",
      tzid: queryParams.get("tzid") || "",
      activity_name: queryParams.get("activity_name") || "Consultation",
      activity_id: queryParams.get("activity_id") || "",
      docname: queryParams.get("docname") || "",
      activity_amount: queryParams.get("activity_amount") || "",
      pmobileno: "",
      newdate: queryParams.get("newdate") || new Date().toISOString().split("T")[0],
      slotid: queryParams.get("slotid") || "",
      slotfrom: queryParams.get("slotfrom") || "",
      slotto: queryParams.get("slotto") || "",
      addrel: queryParams.get("addrel") || "",
      note: queryParams.get("note") || "",
    })
  }, [])

  const fetchStates = () => {
    const token = localStorage.getItem("access_token")
    fetch("https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/util/state", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("States data:", data)
        setStates(data.states || [])
      })
      .catch((err) => {
        console.error("State fetch error:", err)
        setError("Failed to fetch states")
      })
  }

  const handleStateChange = (e) => {
    const stateValue = e.target.value
    setSelectedState(stateValue)
    setFormData({
      ...formData,
      state: stateValue,
      city: "",
    })
    setSelectedCity("")
    if (stateValue) {
      fetchCities(stateValue)
    } else {
      setCities([])
    }
  }

  const handleCityChange = (e) => {
    const cityValue = e.target.value
    setSelectedCity(cityValue)
    setFormData({
      ...formData,
      city: cityValue,
    })
  }

  const fetchCities = async (state) => {
    setLoading(true)
    setCities([])
    const token = localStorage.getItem("access_token")
    try {
      const response = await fetch("https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/util/city", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ state }),
      })
      const data = await response.json()
      console.log("Cities data:", data)
      setCities(data.cities || [])
    } catch (err) {
      console.error("City fetch error:", err)
      setError("Failed to fetch cities")
    }
    setLoading(false)
  }

  // Send OTP function
  const handleSendOtp = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }

    if (!mobileNumber || mobileNumber.length !== 10) {
      setError("Please enter a valid 10-digit mobile number")
      return
    }

    setIsSearching(true)
    setError("")

    try {
      const token = localStorage.getItem("access_token")

      // Create params object with ONLY the fields seen in the successful request
      const params = {
        tzid: appointmentParams.tzid,
        newdate: appointmentParams.newdate,
        doctor_id: appointmentParams.doctor_id,
        docname: appointmentParams.docname,
        activity_name: appointmentParams.activity_name,
        activity_id: appointmentParams.activity_id,
        activity_amount: appointmentParams.activity_amount,
        slotid: appointmentParams.slotid,
        slotfrom: appointmentParams.slotfrom,
        slotto: appointmentParams.slotto,
        note: appointmentParams.note || "",
        pmobileno: mobileNumber,
      }

      console.log("Request payload:", JSON.stringify(params))

      // Send request to get OTP
      const response = await fetch(
        "https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/sendotp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(params),
        },
      )

      console.log("Response status:", response.status, response.statusText)

      if (!response.ok) {
        const errorText = await response.text()
        console.log(errorText)

        try {
          const errorData = JSON.parse(errorText)
          console.log("Server error response:", errorData)
          setError(`Server error: ${errorData.message || "Unknown error"}`)
        } catch (e) {
          setError(`Server error (${response.status}): ${errorText || response.statusText}`)
        }
        return
      }

      const data = await response.json()
      console.log("OTP response:", data)

      if (data.message === "OTP sent to entered mobile no.") {
        setShowOtpInput(true)
        setServerOtp(data.otp)
        toast.success("OTP has been sent to your mobile number")
      } else {
        setError(data.message || "Failed to send OTP. Please try again.")
      }
    } catch (error) {
      console.error("Error sending OTP:", error)
      setError(`Error: ${error.message || "Unknown error"}`)
    } finally {
      setIsSearching(false)
    }
  }

  // Verify OTP and then search for patient
  const handleVerifyOtp = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }

    if (!otp) {
      setError("Please enter the OTP")
      return
    }

    setIsVerifyingOtp(true)
    setError("")

    try {
      // First verify if entered OTP matches with the one received from server
      if (otp === serverOtp.toString()) {
        console.log(otp, serverOtp);
        
        setOtpVerified(true)
        toast.success("OTP verified successfully!")
        // Now proceed with patient search
        await searchPatientDetails()
      } else {
        setError("Invalid OTP. Please try again.")
        toast.error("Invalid OTP. Please try again.")
      }
    } catch (error) {
      console.error("Error verifying OTP:", error)
      setError("Failed to verify OTP. Please try again.")
      toast.error("Failed to verify OTP. Please try again.")
    } finally {
      setIsVerifyingOtp(false)
    }
  }

  // Function to search patient details after OTP verification
  const searchPatientDetails = async () => {
    setIsSearching(true)
    setError("")

    try {
      const token = localStorage.getItem("access_token")

      const params = { ...appointmentParams, pmobileno: mobileNumber }

      // Create query string
      const queryParams = new URLSearchParams(params)

      // Fetch patient details with authorization header
      const response = await fetch(
        `https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/patientdetails?${queryParams}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      const data = await response.json()
      console.log(data)

      if (data.message === "Patient record found registered with this service") {
        // Patient exists
        setPatientData(data.patient)
        setRelations(data.relations || [])
        setUserRelations(data.userrelations || [])
        setShowForm(false)

        // Pre-fill form with patient data
        if (data.patient) {
          const patient = data.patient
          // Parse age
          let ageYears = 0,
            ageMonths = 0,
            ageDays = 0
          if (patient.age && patient.age.includes("years")) {
            const ageParts = patient.age.match(/(\d+) years (\d+) months (\d+) days/)
            if (ageParts) {
              ageYears = Number.parseInt(ageParts[1]) || 0
              ageMonths = Number.parseInt(ageParts[2]) || 0
              ageDays = Number.parseInt(ageParts[3]) || 0
            } else {
              ageYears = Number.parseInt(patient.age) || 0
            }
          } else {
            ageYears = Number.parseInt(patient.age) || 0
          }

          setFormData({
            salutation: patient.user_salutation || "Miss",
            name: patient.user_name || "",
            ageYears,
            ageMonths,
            ageDays,
            dateOfBirth: patient.dob !== "0000-00-00" ? patient.dob : "",
            mobile: patient.user_id || mobileNumber,
            email: patient.user_mail || "",
            gender: patient.gender === "Male" ? "Male" : patient.gender === "Female" ? "Female" : "Trans",
            addressLine1: patient.adr1 || "",
            addressLine2: patient.adr2 || "",
            state: patient.state || "",
            city: patient.city || "",
            country: patient.country || "India",
            referredBy: "",
            relation_id: "",
          })
        }
      } else {
        // Patient doesn't exist, show form
        setPatientData(null)
        setShowForm(true)
        setRelations(data.relations || [])
        setFormData({
          ...formData,
          mobile: mobileNumber,
        })
      }
    } catch (error) {
      setError("Failed to search patient. Please try again.")
      console.error("Search error:", error)
    } finally {
      setIsSearching(false)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    // If date of birth was changed, calculate and update age fields
    if (name === "dateOfBirth") {
      const ageValues = calculateAge(value)

      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        ageYears: ageValues.years,
        ageMonths: ageValues.months,
        ageDays: ageValues.days,
      }))
    } else {
      // For all other fields, just update normally
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }))
    }
  }

  const handleRelationSelect = (e) => {
    const relativeId = e.target.value
    setSelectedRelativeId(relativeId)

    if (relativeId === "") {
      return // No selection, do nothing
    }

    // Find the selected relative from userRelations
    const selectedRelative = userRelations.find((rel) => rel.id === Number.parseInt(relativeId))

    if (selectedRelative) {
      // Parse age
      let ageYears = 0,
        ageMonths = 0,
        ageDays = 0
      if (selectedRelative.age && selectedRelative.age.includes("years")) {
        const ageParts = selectedRelative.age.match(/(\d+) years (\d+) months (\d+) days/)
        if (ageParts) {
          ageYears = Number.parseInt(ageParts[1]) || 0
          ageMonths = Number.parseInt(ageParts[2]) || 0
          ageDays = Number.parseInt(ageParts[3]) || 0
        }
      } else {
        ageYears = Number.parseInt(selectedRelative.age) || 0
      }

      // Pre-fill form with selected relative's data
      setFormData({
        salutation: selectedRelative.user_salutation || "Miss",
        name: selectedRelative.user_name || "",
        ageYears,
        ageMonths,
        ageDays,
        dateOfBirth: selectedRelative.dob !== "0000-00-00" ? selectedRelative.dob : "",
        mobile: selectedRelative.relative_phone_no || formData.mobile,
        email: selectedRelative.user_mail || "",
        gender: selectedRelative.gender === "Male" ? "Male" : selectedRelative.gender === "Female" ? "Female" : "Trans",
        addressLine1: selectedRelative.adr1 || "",
        addressLine2: selectedRelative.adr2 || "",
        state: selectedRelative.state || "",
        city: selectedRelative.city || "",
        country: selectedRelative.country || "India",
        referredBy: "",
        relation_id: selectedRelative.relation_id,
      })
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      const token = localStorage.getItem("access_token")

      // Different payload format for new vs existing patient
      let appointmentData
      let endpoint

      if (patientData && selectedRelativeId) {
        // Booking for existing patient's relative
        const selectedRelative = userRelations.find((rel) => rel.id === Number.parseInt(selectedRelativeId))

        if (!selectedRelative) {
          setIsLoading(false)
          alert("Selected relative not found. Please try again.")
          return
        }

        appointmentData = {
          doctor_id: appointmentParams.doctor_id,
          tzid: appointmentParams.tzid,
          docname: appointmentParams.docname,
          newdate: appointmentParams.newdate,
          note: appointmentParams.note,
          activity_name: appointmentParams.activity_name,
          activity_id: appointmentParams.activity_id,
          activity_amount: appointmentParams.activity_amount,
          slotid: appointmentParams.slotid,
          slotfrom: appointmentParams.slotfrom,
          slotto: appointmentParams.slotto,
          pmobileno: mobileNumber,
          patientname: selectedRelative.user_name,
          userid: selectedRelative.id,
        }

        endpoint = "https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/bookappointment"
      } else if (patientData) {
        // Booking for existing patient
        appointmentData = {
          doctor_id: appointmentParams.doctor_id,
          tzid: appointmentParams.tzid,
          docname: appointmentParams.docname,
          newdate: appointmentParams.newdate,
          note: appointmentParams.note,
          activity_name: appointmentParams.activity_name,
          activity_id: appointmentParams.activity_id,
          activity_amount: appointmentParams.activity_amount,
          slotid: appointmentParams.slotid,
          slotfrom: appointmentParams.slotfrom,
          slotto: appointmentParams.slotto,
          pmobileno: mobileNumber,
          patientname: patientData.user_name,
          userid: patientData.id,
        }

        endpoint = "https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/bookappointment"
      } else {
        // New patient registration
        appointmentData = {
          doctor_id: appointmentParams.doctor_id,
          tzid: appointmentParams.tzid,
          docname: appointmentParams.docname,
          newdate: appointmentParams.newdate,
          note: appointmentParams.note,
          activity_name: appointmentParams.activity_name,
          activity_id: appointmentParams.activity_id,
          activity_amount: appointmentParams.activity_amount,
          slotid: appointmentParams.slotid,
          slotfrom: appointmentParams.slotfrom,
          slotto: appointmentParams.slotto,
          salutation: formData.salutation,
          patfname: formData.name,
          patmobileno: formData.mobile,
          patemail: formData.email,
          patageyear: formData.ageYears.toString(),
          patagemonth: formData.ageMonths.toString(),
          patageday: formData.ageDays.toString(),
          patdob: formData.dateOfBirth || "0000-00-00",
          patgender: formData.gender,
          patadrone: formData.addressLine1,
          patadrtwo: formData.addressLine2,
          patcity: formData.city,
          patstate: formData.state,
          patcountry: formData.country,
        }

        endpoint = "https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/patientdetails"
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(appointmentData),
      })
      console.log("Response status:", response.status, response.statusText)
      const result = await response.json()
      console.log(result, "hari")
      console.log(result.appid, "hari")
      console.log(result.userid, "hari")

      if (result.message && result.message.includes("Appointment booked")) {
        navigate('/book_appointment/appointment_confirmation', {
          state: {
            appId: result.appid,
            userId:result.userid,
            activityAmount: appointmentParams.activity_amount,
            docName: appointmentParams.docname,
            activityName: appointmentParams.activity_name,
            selectedTimeSlot: {
              slotId: appointmentParams.slotid,
              slotFrom: appointmentParams.slotfrom,
              slotTo: appointmentParams.slotto
            }
          }
        });

        // For Next.js, we'll show a success message instead
        // toast.success("Appointment booked successfully!")
        console.log("Appointment Details:", {
          appId: result.appid,
          userId: result.userid,
          activityAmount: appointmentParams.activity_amount,
          docName: appointmentParams.docname,
          activityName: appointmentParams.activity_name,
          selectedTimeSlot: {
            slotId: appointmentParams.slotid,
            slotFrom: appointmentParams.slotfrom,
            slotTo: appointmentParams.slotto,
          },
        })
      } else {
        alert(`Failed to book appointment: ${result.message || "Unknown error"}`)
      }
    } catch (error) {
      console.error("Error booking appointment:", error)
      alert("Failed to book appointment. Please try again later.")
    } finally {
      setIsLoading(false)
    }
  }

  const handleAddRelative = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      const token = localStorage.getItem("access_token")

      console.log("Form data:", formData)
      console.log("Relations array:", relations)

      // Find the selected relation
      let selectedRelation = null
      if (formData.relation_id) {
        selectedRelation = relations.find((r) => r.id === Number.parseInt(formData.relation_id))
      }

      console.log("Selected relation:", selectedRelation)

      // Prepare data for adding relative
      const relativeData = {
        tzid: appointmentParams.tzid,
        newdate: appointmentParams.newdate,
        doctor_id: appointmentParams.doctor_id,
        docname: appointmentParams.docname,
        activity_name: appointmentParams.activity_name,
        activity_id: appointmentParams.activity_id,
        activity_amount: appointmentParams.activity_amount,
        slotid: appointmentParams.slotid,
        slotfrom: appointmentParams.slotfrom,
        slotto: appointmentParams.slotto,
        note: appointmentParams.note || "Patient has mild fever.",
        pmobileno: mobileNumber,
        relation: selectedRelation ? selectedRelation.id : formData.relation_id || "8",
        salutation: formData.salutation || "Mr.",
        relname: formData.name,
        relageyear: formData.ageYears,
        relagemonth: formData.ageMonths,
        relageday: formData.ageDays,
        reldob: formData.dateOfBirth || "0000-00-00",
        rgender: formData.gender,
        reladd: "yes",
        relstate: formData.state,
        relcity: formData.city,
        relmobileno: formData.mobile,
        sameadr: "sameadr",
      }

      console.log("Sending relative data:", relativeData)

      // Add relative API call
      const response = await fetch(
        "https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/addrelative",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(relativeData),
        },
      )

      if (!response.ok) {
        const errorText = await response.text()
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`)
      }

      const result = await response.json()
      console.log("Add relative API response:", result)

      // The API doesn't return the ID of the newly added relative
      // So we need to search for patient details again to get the updated list with IDs

      if (result.message === "Relative added successfully") {
        // Create query parameters for fetching updated patient data
        const queryParams = new URLSearchParams({
          tzid: appointmentParams.tzid,
          newdate: appointmentParams.newdate,
          doctor_id: appointmentParams.doctor_id,
          activity_name: appointmentParams.activity_name,
          activity_id: appointmentParams.activity_id,
          docname: appointmentParams.docname,
          activity_amount: appointmentParams.activity_amount,
          slotid: appointmentParams.slotid,
          slotfrom: appointmentParams.slotfrom,
          slotto: appointmentParams.slotto,
          pmobileno: mobileNumber,
          addrel: "yes",
          note: appointmentParams.note || "Patient has mild fever.",
        })

        // Fetch updated patient details
        const patientResponse = await fetch(
          `https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/patientdetails?${queryParams}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        if (!patientResponse.ok) {
          throw new Error(`Failed to fetch updated patient details: ${patientResponse.status}`)
        }

        const patientData = await patientResponse.json()
        console.log("Updated patient data:", patientData)

        // Update the user relations with the new data from API
        if (patientData.userrelations) {
          setUserRelations(patientData.userrelations)
          toast.success("Relative added successfully!")
        }

        // Reset form after successful addition
        setFormData({
          salutation: "Mr.",
          name: "",
          mobile: "",
          email: "",
          ageYears: "",
          ageMonths: "",
          ageDays: "",
          dateOfBirth: "",
          gender: "Male",
          state: "",
          city: "",
          addressLine1: "",
          addressLine2: "",
          country: "",
          relation_id: "",
        })

        setShowForm(false)
      } else {
        toast.error("Failed to add relative")
      }
    } catch (error) {
      console.error("Error adding relative:", error)
      toast.error(`Failed to add relative: ${error.message}`)
    } finally {
      setIsLoading(false)
    }
  }

  const calculateAge = (dateOfBirth) => {
    // If no date is provided, return empty values
    if (!dateOfBirth) {
      return { years: "", months: "", days: "" }
    }

    const dob = new Date(dateOfBirth)
    const today = new Date()

    let years = today.getFullYear() - dob.getFullYear()

    let months = today.getMonth() - dob.getMonth()

    let days = today.getDate() - dob.getDate()

    if (days < 0) {
      // Borrow days from previous month
      const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      const daysInPreviousMonth = new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0).getDate()

      days += daysInPreviousMonth
      months -= 1
    }

    if (months < 0) {
      months += 12
      years -= 1
    }

    years = Math.max(0, years)
    months = Math.max(0, months)
    days = Math.max(0, days)

    return { years, months, days }
  }

  function getCurrentStep() {
    if (!otpVerified) return 1
    if (!patientData) return 3
    return 4
  }
  const StyledWrapper = styled.div`
  .loader {
    width: 48px;
    height: 48px;
    margin: auto;
    position: relative;
  }

  .loader:before {
    content: '';
    width: 48px;
    height: 5px;
    background: #f0808050;
    position: absolute;
    top: 60px;
    left: 0;
    border-radius: 50%;
    animation: shadow324 0.5s linear infinite;
  }

  .loader:after {
    content: '';
    width: 100%;
    height: 100%;
    background: #f08080;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4px;
    animation: jump7456 0.5s linear infinite;
  }

  @keyframes jump7456 {
    15% {
      border-bottom-right-radius: 3px;
    }

    25% {
      transform: translateY(9px) rotate(22.5deg);
    }

    50% {
      transform: translateY(18px) scale(1, .9) rotate(45deg);
      border-bottom-right-radius: 40px;
    }

    75% {
      transform: translateY(9px) rotate(67.5deg);
    }

    100% {
      transform: translateY(0) rotate(90deg);
    }
  }

  @keyframes shadow324 {

    0%,
      100% {
      transform: scale(1, 1);
    }

    50% {
      transform: scale(1.2, 1);
    }
  }`;

  const styles = `
.user-detail-container {
  min-height: 100vh;
  // background: white;
  padding: 1rem;
  width: 70%;
  margin: 0 auto; /* center it */
}
@media (max-width: 768px) {
  .user-detail-container {
    width: 100%;
  }
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header {
  text-align: center;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  animation: slideInDown 0.6s ease-out;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.brand-logo {
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 30px;
  background-color: white;
  border-radius: 50%;
  padding: 15px;
  
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 1s ease;
}


.brand-logo:hover .logo-img {
  transform: rotate(360deg);
}

.header h1 {
  font-size: 2rem;
  font-weight: bold;
  background: linear-gradient(135deg, #6c5ce7 0%, #6c5ce7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  animation: textGlow 2s ease-in-out infinite alternate;
}

@keyframes textGlow {
  from {
    filter: brightness(1);
  }
  to {
    filter: brightness(1.2);
  }
}

.header p {
  color: #f3f1f1de;
  margin: 0.5rem 0 0 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.progress-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(15px);
  border-radius: 2rem;
  padding: 1rem 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: fadeInScale 0.8s ease-out both;
}

@keyframes fadeInScale {
  0% {
    opacity: 0;
    transform: scale(0.9) translateY(30px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.progress-step {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}

.step-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0.9);
  opacity: 0.7;
}

.step-icon.active {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%);
  color: white;
  transform: scale(1.2);
  opacity: 1;
  animation: pulseGlow 1s ease-out;
  box-shadow: 0 0 15px rgba(108, 92, 231, 0.6);
}

@keyframes pulseGlow {
  0% {
    box-shadow: 0 0 0 rgba(108, 92, 231, 0.6);
    transform: scale(0.8);
  }
  50% {
    box-shadow: 0 0 20px rgba(108, 92, 231, 0.8);
    transform: scale(1.3);
  }
  100% {
    box-shadow: 0 0 10px rgba(108, 92, 231, 0.5);
    transform: scale(1.2);
  }
}

.step-label {
  font-size: 1rem;
  font-weight: 500;
  color: #999;
  opacity: 0.6;
  transform: translateY(5px);
  transition: all 0.3s ease;
}

.step-label.active {
  color: #6c5ce7;
  font-weight: 600;
  opacity: 1;
  transform: translateY(0);
}

.form-container {
  animation: fadeIn 1s ease-out 0.4s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.form-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-bottom: 1rem;
}

.form-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: cardSlideIn 0.6s ease-in-out forwards;
  opacity: 0;
  transform: translateY(20px);
}

.form-card:nth-child(1) { animation-delay: 0.1s; }
.form-card:nth-child(2) { animation-delay: 0.2s; }
.form-card:nth-child(3) { animation-delay: 0.3s; }

@keyframes cardSlideIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-card:hover {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  transform: translateY(-8px) scale(1.02);
}

.form-card::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: radial-gradient(circle, rgba(180, 200, 255, 0.25) 0%, rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  pointer-events: none;
}

.form-card:hover::before {
  animation: rippleGlow 1s ease-out forwards;
}

@keyframes rippleGlow {
  0% {
    width: 0;
    height: 0;
    opacity: 0.6;
  }
  70% {
    width: 250%;
    height: 250%;
    opacity: 0.2;
  }
  100% {
    width: 300%;
    height: 300%;
    opacity: 0;
  }
}

.card-header {
  margin-bottom: 1rem;
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  color: #333;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
  font-size: 0.875rem;
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid transparent;
  background: rgba(248, 249, 250, 0.8);
  border-radius: 0.75rem;
  font-size: 0.875rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.form-control:hover {
  background: rgba(233, 236, 239, 0.9);
  transform: translateY(-1px);
}

.form-control:focus {
  outline: none;
  background: white;
  border-color: #6c5ce7;
  box-shadow: 0 0 0 4px rgba(108, 92, 231, 0.1);
  transform: translateY(-2px);
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s, height 0.3s;
}

.btn:hover::before {
  width: 300px;
  height: 300px;
}

.btn-primary {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(108, 92, 231, 0.3);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 8px 25px rgba(108, 92, 231, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.7);
  color: #666;
  border: 1px solid rgba(108, 92, 231, 0.2);
}

.btn-secondary:hover {
  background: rgba(108, 92, 231, 0.1);
  color: #6c5ce7;
  border-color: #6c5ce7;
  transform: translateY(-2px);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.patient-info-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 1rem;
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.patient-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.detail-item {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
}

.detail-item:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: translateY(-2px);
}

.detail-label {
  font-size: 0.75rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: left;
  width: 35%;
}

.detail-value {
  font-weight: 600;
  color: #333;
}

.relatives-section {
  margin-top: 2rem;
}

.relatives-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  margin-bottom: 1rem;
}

.relative-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.relative-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.relative-card.selected {
  border-color: #6c5ce7;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-content {
  text-align: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6c5ce7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  background: rgba(255, 235, 235, 0.9);
  color: #d32f2f;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border-left: 4px solid #d32f2f;
}

.success-message {
  background: rgba(232, 245, 233, 0.9);
  color: #2e7d32;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border-left: 4px solid #2e7d32;
}

.footer {
  text-align: center;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
  animation: fadeIn 1s ease-out 1.2s both;
}

.footer p {
  font-size: 0.75rem;
  color: #f7f5f5ff;
  margin: 0;
}

.footer a {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.footer a:hover {
  text-decoration: underline;
  transform: scale(1.05);
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .progress-steps {
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
  }
  
  .header {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }
  
  .header h1 {
    font-size: 1.5rem;
  }
  
  .patient-details {
    grid-template-columns: 1fr;
  }
  
  .relatives-grid {
    grid-template-columns: 1fr;
  }
  
  .form-card {
    padding: 1rem;
  }
}

* {
  scroll-behavior: smooth;
}

*:focus {
  outline: 2px solid #6c5ce7;
  outline-offset: 2px;
}
`

  return (
    <div className="user-detail-container">
      <style>{styles}</style>
      <div className="container">
        <div className="header">
          <div className="brand-logo">
            <img src="./hlogo.png" alt="HealTrail Logo" className="logo-img" />
          </div>
          <div>
            <h1> Appointments by HealTrail</h1>
            <p style={{color:"#fbfafaff"}}>
               Your Health Journey Starts Here
            </p>
          </div>
        </div>

        <div className="progress-steps">
          {[
            { step: 1, icon: <Icons.Phone />, label: "Verify" },
            { step: 2, icon: <Icons.User />, label: "Patient" },
            { step: 3, icon: <Icons.MessageSquare />, label: "Details" },
            { step: 4, icon: <Icons.CheckCircle />, label: "Complete" },
          ].map(({ step, icon, label }, index) => (
            <div key={step} className="progress-step">
              <div className={`step-icon ${getCurrentStep() >= step ? "active" : ""}`}>{icon}</div>
              <span className={`step-label ${getCurrentStep() >= step ? "active" : ""}`}>{label}</span>
              {index < 3 && <Icons.ArrowRight />}
            </div>
          ))}
        </div>

        <div className="form-container">
          {/* OTP Verification Section */}
          {!otpVerified && (
            <div className="form-grid">
              <Card>
                <CardHeader>
                  <CardTitle>
                    <Icons.Phone /> Mobile Verification
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="form-group">
                    <label>Mobile Number</label>
                    <Input
                      type="tel"
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                      placeholder="Enter your mobile number"
                      maxLength="10"
                    />
                  </div>
                  <Button onClick={handleSendOtp} disabled={isLoading || mobileNumber.length !== 10}>
                    {isLoading ? (
                      <>
                        <Icons.Loader2 /> Sending...
                      </>
                    ) : (
                      <>
                        Send OTP <Icons.ArrowRight />
                      </>
                    )}
                  </Button>
                </CardContent>
              </Card>

              {showOtpInput && (
                <Card>
                  <CardHeader>
                    <CardTitle>
                      <Icons.Lock /> Enter OTP
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="form-group">
                      <label>OTP Code</label>
                      <Input
                        type="text"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="Enter 6-digit OTP"
                        maxLength="6"
                      />
                    </div>
                    <Button onClick={handleVerifyOtp} disabled={isLoading || otp.length !== 4}>
                      {isLoading ? (
                        <>
                          <Icons.Loader2 /> Verifying...
                        </>
                      ) : (
                        <>
                          Verify OTP <Icons.CheckCircle />
                        </>
                      )}
                    </Button>
                  </CardContent>
                </Card>
              )}
            </div>
          )}

          {/* Patient Information Section */}
          {otpVerified && patientData && (
            <Card className="patient-info-card">
              <CardHeader>
                <CardTitle>
                  <Icons.User /> Patient Information
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="patient-details">
                  <div className="detail-item">
                    <span className="detail-label">Name:</span>
                    <span className="detail-value">{patientData.user_name}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Mobile:</span>
                    <span className="detail-value">{patientData.user_id}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Age:</span>
                    <span className="detail-value">{patientData.age}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Gender:</span>
                    <span className="detail-value">{patientData.gender}</span>
                  </div>
                </div>

                {/* Relatives Section */}
                {userRelations.length > 0 && (
                  <div className="relatives-section">
                    <h4>
                      <Icons.Heart /> Book for Relative
                    </h4>
                    <div className="relatives-grid">
                      {userRelations.map((relative) => (
                        <div
                          key={relative.id}
                          className={`relative-card ${selectedRelativeId === relative.id ? "selected" : ""}`}
                          onClick={() => setSelectedRelativeId(relative.id)}
                        >
                          <div className="detail-item">
                            <span className="detail-label">Name:</span>
                            <span className="detail-value">{relative.user_name}</span>
                          </div>
                          <div className="detail-item">
                            <span className="detail-label">Relation:</span>
                            <span className="detail-value">{relative.relation}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div style={{ marginTop: "1rem", display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                  <Button onClick={handleSubmit} disabled={isLoading}>
                    {isLoading ? (
                      <>
                        <Icons.Loader2 /> Booking...
                      </>
                    ) : (
                      <>
                        <Icons.Calendar /> Book Appointment
                      </>
                    )}
                  </Button>
                  <Button variant="ghost" onClick={() => setShowForm(true)}>
                    <Icons.User /> Add Relative
                  </Button>
                </div>
              </CardContent>
            </Card>
          )}

          {/* Registration Form */}
          {otpVerified && showForm && (
            <div className="form-grid">
              <Card>
                <CardHeader>
                  <CardTitle>
                    <Icons.User /> Personal Information
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="form-group">
                    <label>Full Name *</label>
                    <Input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Date of Birth *</label>
                    <Input type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} />
                  </div>
                  <div className="form-group">
                    <label>Gender *</label>
                    <Select name="gender" value={formData.gender} onChange={handleChange}>
                      <SelectItem value="placeholder">Select Gender</SelectItem>
                      <SelectItem value="Male">Male</SelectItem>
                      <SelectItem value="Female">Female</SelectItem>
                      <SelectItem value="Other">Other</SelectItem>
                    </Select>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>
                    <Icons.MapPin /> Address Information
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="form-group">
                    <label>State *</label>
                    <Select name="state" value={formData.state} onChange={handleStateChange}>
                      <SelectItem value="placeholder">Select State</SelectItem>
                      {states.map((stateObj) => (
                        <SelectItem key={stateObj.State} value={stateObj.State}>
                          {stateObj.State}
                        </SelectItem>
                      ))}
                    </Select>
                  </div>
                  <div className="form-group">
                    <label>City *</label>
                    <Select name="city" value={formData.city} onChange={handleCityChange} disabled={!cities.length}>
                      <SelectItem value="placeholder">Select City</SelectItem>
                      {cities.map((cityObj) => (
                        <SelectItem key={cityObj.City} value={cityObj.City}>
                          {cityObj.City}
                        </SelectItem>
                      ))}
                    </Select>
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <Textarea
                      name="addressLine1"
                      value={formData.addressLine1}
                      onChange={handleChange}
                      placeholder="Enter your address"
                      rows="3"
                    />
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>
                    <Icons.Mail /> Contact Information
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="form-group">
                    <label>Email</label>
                    <Input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                    />
                  </div>
                  <div className="form-group">
                    <label>Emergency Contact</label>
                    <Input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="Emergency contact number"
                    />
                  </div>
                </CardContent>
              </Card>
            </div>
          )}

          {/* Submit Button */}
          {otpVerified && showForm && (
            <div style={{ textAlign: "center", marginTop: "2rem" }}>
              <Button
                onClick={patientData ? handleAddRelative : handleSubmit}
                disabled={isLoading}
                className="btn-primary"
                style={{
                  minWidth: "250px",
                  height: "3.5rem",
                  fontSize: "1rem",
                  fontWeight: "600",
                  borderRadius: "1.75rem",
                }}
              >
                {isLoading ? (
                  <>
                    <Icons.Loader2 />
                    Registering Patient
                  </>
                ) : (
                  <>
                     Register Patient 
                  </>
                )}
              </Button>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="footer">
          <p style={{ fontSize: "0.75rem", color: "#f7f5f5ff" }}>
            Powered by{" "}
            <a href="https://www.healtrail.com/" target="_blank" rel="noopener noreferrer">
              HealTrail
            </a>
          </p>
        </div>

        {/* Loading Overlay */}
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-content">
              <StyledWrapper>
      <div className="loader" />
    </StyledWrapper>
              <p>Processing your request...</p>
            </div>
          </div>
        )}

        {/* Error/Success Messages */}
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

export default UserDetail
